import SidebarNavigation from 'components/organisms/SidebarNavigation/SidebarNavigation';
import { FC } from 'react';
import { candidateSidebarConfig } from './CandidateInfoNavigation.constants';

const CandidateInfoNavigation: FC = () => {
  return <SidebarNavigation routes={candidateSidebarConfig} />;
};

export default CandidateInfoNavigation;
